import { render } from "./EditorPage.vue?vue&type=template&id=65c27cb6&scoped=true"
import script from "./EditorPage.vue?vue&type=script&lang=js"
export * from "./EditorPage.vue?vue&type=script&lang=js"

import "./EditorPage.vue?vue&type=style&index=0&id=65c27cb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c27cb6"]])

export default __exports__